import React from 'react';
import classNames from 'classnames';

import FormattedDateTime from 'rebook/apps/base/components/FormattedDateTime';
import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';

import styles from './style.scss';


const CurrentSubscriptionLabel = ({ subsciptionActiveTill, isPro, extraClassName }) => {
  return (
    <div className={classNames(styles.currentSubscriptionContainer, extraClassName)}>
      <div className={styles.currentSubscriptionHeader}>
        {isPro
          ? <SubscriptionIcon type="premiumChecked" extraClassName={styles.currentSubscriptionIcon} />
          : <SubscriptionIcon type="standardChecked" extraClassName={styles.currentSubscriptionIcon} />
        }
        <div className={styles.currentSubscriptionText}>
          {isPro
            ? <span>Вам доступны все<br />книги MyBook</span>
            : <span>Вам доступны книги<br />стандартной подписки</span>
          }
        </div>
      </div>
      <div className={styles.currentSubscriptionFooter}>
        до <strong><FormattedDateTime timestamp={subsciptionActiveTill} format="D MMMM YYYY" /></strong>
      </div>
    </div>
  );
};

export default CurrentSubscriptionLabel;
